

<template >
    
    <div class="cell medium-10 small-12" style="padding:2px">
      
        <template v-if="comps && comps.length">
            <nav>
                <div class="grid-x" style="margin-top:5px">
<div id="selector" class="cell text-center">
                    <button v-if="selectedcomps.length > 0" id="matchselector" class="button qheadercolour" style="color:#0d0638;margin-top:5px"  @click="clickGo()">{{ langConv('Create a coupon with your selections')}} - <span class="badge alert" style="padding:5px">{{selectedcomps.length}}</span></button>
</div>


                </div>
            </nav>
            <div>         
           
                <tabs @changed="tabChanged">
                    <tab :title="langConv('Match Odds')"  :description="langConv('Match Odds gives the bettor the chance to bet on which team they think will win a given match')" img="" :tabtype="$tabtype.textonly" :isactive="tabid==0" class="qborderfontcolour">
                        <template >
                        

                            <div class="content" v-if="comps && unique(comps,'Co', 'ortpo', '1').length == 0">
                                {{ langConv('No current matches for this sport') }}
                            </div>
                            <div v-for="(row,i) in unique(comps,'Co', 'ortpo', '1')" :key="i">
                          
                            <template v-if="row.Co == opencountry" >
                            
                                <details  open>
                                   
                                    <summary :id="row.Co" class="qsmallfontplus1"><img class="qflagsmall" style="margin-right:4px" :src="'/assets/images/flags/svg/' + row.Co + '.svg'" onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'" :alt="row.Co"/><span style="margin-left:8px">{{ row.Co }}</span></summary>
                                    <div class="grid-x grid-padding-x  qsmallfontplus1 qborderfontcolour" style="padding:5px">
                                        <template v-for="(row2,i2) in comps">
                                            <template  v-if="row2.Co == row.Co && row2.ortpo== 1">
                                                <div class="cell small-12 medium-6 large-4" :key="i2" >
                                                   <template v-if="$store.state.wasSSR">
                                                        <a v-if="row2 && row2.Comp" :href="'/Competition/' + sport + '/' + row2.Comp.replace(/ /g, '-')">{{ row2.Comp }}</a>
                                                   </template> 
                                                   <template v-else>
                                                    <input :name="row2.CoID" class="qpointer" :id="row2.Co + i2" type="checkbox" :value="String(row2.Comp || '').replace(/ /g, '-')" v-model="selectedcomps" >
                                                    <label style="margin-bottom:-5px;overflow: hidden;text-overflow: ellipsis;" class="qsmallfontplus1"  :for="row2.Co + i2">{{row2.Comp}}</label> 
                                                   </template> 
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </details>
                            </template>
                            <template v-else>
                              
                                <details >
                                  
                                    <summary :id="row.Co" class="qsmallfontplus1 qmarginbelow" ><img class="qflagsmall" :src="'/assets/images/flags/svg/' + row.Co + '.svg'" onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'" :alt="row.Co"/><span style="margin-left:8px">{{ row.Co }}</span></summary>
                                    <div class="grid-x " style="padding:3px">
                                        <template v-for="(row2,i2) in comps">
                                            
                                            <template v-if="row2.Co == row.Co && row2.ortpo== 1">
                                                <div class="cell small-12 medium-6 large-4" :key="i2" >
                                                    <template v-if="$store.state.wasSSR">
                                                        <a v-if="row2 && row2.Comp" :href="'/Competition/' + sport + '/' + row2.Comp.replace(/ /g, '-')">{{ row2.Comp }}</a>
                                                   </template> 
                                                   <template v-else>
                                                     
                                                    <input :name="row2.CoID" class="qpointer" :id="row2.Co + i2" type="checkbox" :value="String(row2.Comp.replace(/ /g, '-') || '')" v-model="selectedcomps">
                                                    <label style="margin-bottom:-5px;overflow: hidden;text-overflow: ellipsis;" class="qsmallfontplus1"  :for="row2.Co + i2">{{row2.Comp}}</label>
                                                </template>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </details>
                            </template>

                            </div>
                        </template> 
                       
                    </tab>
                    <tab :title="langConv('Outright Winner Odds')" :description="langConv('Outright Winner Odds gives the better who will win the league / tournament')" img="" :tabtype="$tabtype.textonly" :isactive="tabid==1">
                        <template >

                            <div class="content" v-if="unique(comps,'Co', 'ortpo', '0').length == 0">
                                No current outrights for this sport
                            </div>
                            <div v-for="(row,i) in unique(comps,'Co', 'ortpo', '0')" :key="i">
                            <details>
                                <summary class="qsmallfontplus1 qmarginbelow"><img class="qflagsmall" onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'" :src="'/assets/images/flags/svg/' + row.Co + '.svg'"/><span style="margin-left:8px">{{ row.Co }}</span></summary>
                                <div class="grid-x grid-padding-x small-up-2 medium-up-3 qsmallfontplus1 " style="padding:5px">
                                    <template v-for="(row2,i2) in comps" >

                                        <div class="cell" :key="i2" v-if="row2.Co == row.Co && row2.ortpo == 0">
                                                    <!-- <template v-if="$store.state.wasSSR"> -->
                                                        <a class="qpointer qblacktext" :href="'/Outright/' + sport + '/' +  row2.Comp.replace(/ /g, '-')">{{row2.Comp}}</a>
                                                   <!-- </template> 
                                                   <template v-else>
                                                        <input class="qpointer" style="z-index:1" :id="row2.Co + row2.i" type="checkbox" :value="String(row2.Comp || '').replace(/ /g, '-')" v-model="selectedcomps">&nbsp;{{row2.Comp}}
                                                    </template> -->
                                        </div>
                                    </template>
                                </div>
                            </details>
                            </div>
                        </template>
                    </tab>

                </tabs>
            </div>
        
        </template>
</div>
</template>


<script>
 
   // adapted from https://codepen.io/frogmcw/pen/deqRwa after failing to get the foundation accordian and Vue to work nicely

import tab from '../components/modified3rdpartycomponents/tab.vue'
import tabs from '../components/modified3rdpartycomponents/tabs.vue'

import { fetchData } from '../components/plugins/api.js'

    export default {

        name: "sport",
        metaInfo() {
        const baseUrl = process.env.VUE_APP_WEBSITE || ''
        const path = (this.$route && this.$route.fullPath) ? this.$route.fullPath : '/'     
        return {
            title: this.langConv('Select the leagues to view for') + " " + this.sportname + " | Oddsgalore",
            meta: [{
        
                vmid: 'description',
                name: 'description',
                content: this.langConv("Select the Sports Competition(s) you want to view for") + " " + this.sportname
            },
            {
                vmid: 'og:title',
                property: 'og:title',
                content:this.langConv('Select the leagues to view for') + " " + this.sportname
            }
            ],
            link: [{
                vmid: 'canonical',
                rel: 'canonical',
                href: baseUrl + path
            }]
        }
    },
        data: function () {
            return {
                
                loadedcomps: false,
                selectedcomps: [],
                tpo: 1,
                btid: 1,
                sportname: this.sport,
                tabid: 0
            };
        },
        computed: {
                comps() {
                    return this.$store.state.competitionsforsportstable;
                }
        },
        watch: {
           '$route.params.sport': 'loadData'
        },

        async asyncData({ app,
            store,
            route,
            localLoader,
            isServer}) {

              

            const data =   await fetchData("FeatureTables.svc/CompetitionsbySport", {

                    params: {
                        noitems: 999,
                        country: store.state.country,
                        sport: 'Soccer'
                    }

                }).catch(error => {
                   console.log("axios error")
               });
             

                let jsonData = JSON.parse(data)[0].BO;

                store.commit('setCompetitionsforSportsTable', jsonData )
               
        },
        components: {
            tab,
            tabs
        },

        props: {

            sport: String,
            opencountry: String
        },

        async created() {

              await this.loadData();

        },
    
        

        beforeRouteUpdate(to, from, next) {

            this.sportname = to.params.sport;
            this.opencounty = to.params.opencounty;
            //this.competitionsforSportTable();
            next();
            
        },

        methods: {

            async loadData() {
                
                const data =   await fetchData("FeatureTables.svc/CompetitionsbySport", {

                    params: {
                        noitems: 999,
                        country: this.$store.state.country,
                        sport: this.sport
                    }

                    })

                    let jsonData = JSON.parse(data)[0].BO;

                    this.$store.commit('setCompetitionsforSportsTable', jsonData )
                
            },

            clickGo: function() {

                    // Navigate programmatically
                    const seoPath = this.selectedcomps.join('&')

                    //
                    let nospacesport = this.sport.replace(/\s/g, "")

                    //which tab
                    if (this.tabid == 0 || this.tabid == undefined) {
                        this.$router.push({ name: 'events', params: { sport: nospacesport, eventparams: seoPath } })
                    } 
                    else {
                        this.$router.push({ name: 'outrightodds', params: { sport: nospacesport, eventparams: seoPath } })
                    }
            },

            tabChanged: function(tab) {
              
            if (tab != this.tabid) {
                this.tabid = tab;
            }    
        },

            //competitions have 
            // createCoupon: function () {

            //     var URL = '/competition/' + this.selectedcomps.join('/');
            //     this.$router.push(URL);
                
            // },
           
            //get data for odds table
            competitionsforSportTable: function (axios) {

              
                axios.get(process.env.VUE_APP_WEBAPI  + "FeatureTables.svc/CompetitionsbySport", {

                    params: {
                        noitems: 999,
                        country: this.$store.state.countryname,
                        sport: this.sportname
                    }

                }).then(response => {

                    this.competitionsforsport = JSON.parse(response.data)[0].BO; 

                    this.loadedcomps = true;});

            },

        }

    }
</script>

<style scoped>

    details {
        width: 100%;
        /* min-height: 30px; */
        max-width: 1024px;
        padding: 15px 25px 15px 15px;
        margin: 0 auto;
        position: relative;
        font-size: 16px;
        border: 1px solid rgba(0,0,0,.1);
        border-radius: 10px;
        box-sizing: border-box;
        transition: all .3s;
    }

        details + details {
            margin-top: 20px;
        }

        details[open] {
            min-height: 30px;
            /* background-color: #f6f7f8; */
            box-shadow: 2px 2px 20px rgba(0,0,0,.2);
            z-index:1 !important
     
        }

        /* details div {
 
        } */

    summary {
        font-weight: 500;
        cursor: pointer;
    }

        summary:focus {
            outline: none;
        }

        summary::-webkit-details-marker {
            display: none
        }

        summary::after {
            padding: 20px;
            position: absolute;
            top: 50%;
            right: 0;
            color: darkslategray;
            font-size: 12px;
            font-weight:700;
            font-style: normal;
            font-variant-caps: normal;
            font-variant-ligatures: normal;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
            content: ">";
            transform: translateY(-50%);
            transition: .3s ease;
        }

    details[open] summary::after {
        content: "x";
        font-size: 12px;
        top: 0;
        transform: translateY(0);
        transition: .3s ease;
    }

    details[open] summary:hover::after {
        animation: pulse 1s ease;
    }

    @keyframes pulse {
        25% {
            transform: scale(1.1);
        }

        50% {
            transform: scale(1);
        }

        75% {
            transform: scale(1.1);
        }

        100% {
            transform: scale(1);
        }
    }



</style>





